import { Trans } from '@lingui/react'
import classNames from 'classnames'
import { bool, func, shape, string } from 'prop-types'

import { IS_NODE } from 'shared/consts/env'
import { isRebrandingActive } from 'shared/experiments/utils/rebranding'
import noop from 'shared/utils/noop'
import IconArrowLeft from 'views/components/atoms/Icon/IconArrowLeft'
import IconCross from 'views/components/atoms/Icon/IconCross'
import LogoSmall from 'views/components/atoms/LogoSmall'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import {
  usePageProperties,
  usePublicConfig,
} from 'views/utils/shopAndRuntimeConfigUtils'

const OffCanvasMenuHeader = ({
  userData,
  backButton,
  goBackHandler,
  closeMenuHandler,
}) => {
  const { experiments } = usePageProperties()
  const { tenant, shopName } = usePublicConfig()
  const showLogo = isRebrandingActive(experiments) && !backButton
  const classes = classNames('o-OffCanvasView__header l-flex u-no-margin', {
    'u-padding--left': !backButton,
  })

  const headerText = (user, backButtonExists) => {
    if (backButtonExists) {
      return <Trans id="general.link.label.back" />
    }

    if (user?.isLoggedIn) {
      return (
        <>
          <Trans id="offcanvas.header.hello" />
          {` ${user?.isLoggedIn ? user.user.firstname : ''}`}
        </>
      )
    }

    return <Trans id="offcanvas.header.title" />
  }

  return (
    <h3 className={classes} suppressHydrationWarning id="OffCanvasViewHeader">
      {backButton && (
        <ButtonTransparent
          name="go-back-navigation"
          onClick={goBackHandler}
          inline
          alternative
        >
          <IconArrowLeft />
          <span className="a-visuallyhidden">Go Back</span>
        </ButtonTransparent>
      )}

      {showLogo ? (
        <LogoSmall
          tenant={tenant}
          title={shopName}
          alt={shopName}
          shopURL="/"
        />
      ) : (
        <span
          className="l-flex__primary"
          data-clientside-hook="OffCanvasMenu__header-greeting"
          data-cs-mask="true"
        >
          {headerText(userData, backButton)}
        </span>
      )}

      <ButtonTransparent
        name="close-navigation"
        {...(IS_NODE ? { href: '#' } : { onClick: closeMenuHandler })}
        aria-controls="OffCanvasMenu"
        data-clientside-hook="menu-button"
        suppressHydrationWarning
        inline
        alternative
      >
        <IconCross />
        <span className="a-visuallyhidden">Close navigation</span>
      </ButtonTransparent>
    </h3>
  )
}

OffCanvasMenuHeader.propTypes = {
  userData: shape({ isLoggedIn: bool, name: string }),
  backButton: bool,
  goBackHandler: func,
  closeMenuHandler: func,
}

OffCanvasMenuHeader.defaultProps = {
  userData: null,
  backButton: false,
  goBackHandler: noop,
  closeMenuHandler: noop,
}

export default OffCanvasMenuHeader
